import router from '@/router'
import store from '@/store'

import {
  isPkgCode,
  getQueryString,
} from '@/utils'

import { getUserLocalData, getLogo } from '@/utils/auth'

import connectSocket from './connectSocket'

let allowBack = true //    给个默认值true
let isPageLoaded = false
const logo_url = getQueryString('logo_url');
const ground_url = getQueryString('ground_url');

// 获取路由
const jumpRouter = () => {
  const { id } = store.state.component
  router.push({
    path: id
  })
}
router.beforeEach(async (to, from, next) => {
  document.title = '智适应教育-归一化课程'
  // 不验证登录，直接进入
  if (to.meta.allowBack !== undefined) {
    allowBack = to.meta.allowBack
  }
  if (!allowBack) {
    history.pushState(null, null, location.href)
  }
  //如果有登录信息就登录
  if(to.query && to.query.jupiter_token && to.name != 'loading'){
    next({
      path:`/loading`,
      query:to.query
    })
    return
  }
  if (!to.meta.permission) {
    isPageLoaded = true
    // const userInfo = getUserLocalData()
    // connectSocket(userInfo)
    // // 99 教师培训
    // if(userInfo.chapter_type != 99) {
    //   new window.HCISystem.InitSuntory({ account_id: userInfo.account_id, isStudent: true, course_id: userInfo.course_id, });
    // } else {
    //   new window.HCISystem.InitSuntory({ account_id: userInfo.account_id, isStudent: false, course_id: userInfo.course_id, });
    // }
    next()
    return
  }
  if (!isPageLoaded) {
    const cb = () => {
      const userInfo = getUserLocalData()
      connectSocket(userInfo)
      // 99 教师培训
      if(userInfo.chapter_type != 99) {
        new window.HCISystem.InitSuntory({ account_id: userInfo.account_id, isStudent: true,  course_id: userInfo.course_id, });
      } else {
        new window.HCISystem.InitSuntory({ account_id: userInfo.account_id, isStudent: false, course_id: userInfo.course_id, });
      }
      jumpRouter()
    }
    let res
    try {
      res = await store.dispatch('nextStep', { isNextStep: 0, cb: cb, to: to.name })
      if (!res) throw new Error()
    } catch (err) {
      return
    }
    if(res.code !== 200) {
      isPageLoaded = true
      next()
      return
    }
    // 课时包
    if (!isPkgCode(res.code)) {
      isPageLoaded = true
      cb()
    }
  } else {
    next()
  }
})




// WEBPACK FOOTER //
// ./src/permission.js